import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'

import Home from './Components/Home/Home'
import Header from './Components/Header/Header'
import Footer from './Components/Footer/Footer'
import Preloader from './Components/Preloader/Preloader'
import AboutUsMain from './Pages/AboutUsMain/AboutUsMain'
import ProductMain from './Pages/ProductMain/ProductMain'
import CareerPageMain from './Pages/CareerPageMain/CareerPageMain'
import Applyjobform from './Pages/CareerPageMain/Applyjobform/Applyjobform'
import Blogsmain from './Pages/Blogs/Blogsmain'
import BlogDetail from './Pages/Blogs/BlogDetail/BlogDetail'
import BROCHUREMain from './Pages/BROCHURE/BROCHUREMain'
import ContactUs from './Pages/ContactUs/ContactUs'
import INQUIRENOW from './Pages/INQUIRENOW/INQUIRENOW'
import ProductDetails from './Pages/ProductDetails/ProductDetails'
import HelpWidget from './Components/HelpWidget/HelpWidget'
import EventsMain from './Pages/EventsMain/EventsMain'
import ScrollToTop from './Components/ScrollToTop/ScrollToTop'
import Research_Development from './Pages/Research_Development/Research_Development'
import OurJourney from './Pages/OurJourney/OurJourney'
import DirectorWord from './Pages/DirectorWord/DirectorWord'


const AppRoutes = () => {
  const location = useLocation();
  const baseRouteKey = '/' + (location.pathname.split('/')[1] || '');
  return (
    <Routes location={location} key={baseRouteKey}>
      <Route path='/' element={<Home/>}/>
      <Route path='/about-us' element={<AboutUsMain/>}/>
      <Route path='/products' element={<ProductMain/>}/>
      <Route path='/products/:slug' element={<ProductMain/>}/>
      <Route path='/career' element={<CareerPageMain/>}/>
      <Route path='/blog' element={<Blogsmain/>}/>
      <Route path='/blog/:slug' element={<BlogDetail/>}/>
      <Route path='/download' element={<BROCHUREMain/>}/>
      <Route path='/events' element={<EventsMain/>}/>
      <Route path='/contact-us' element={<ContactUs/>}/>
      <Route path='/inquire-now' element={<INQUIRENOW/>}/>
      <Route path='/product-details' element={<ProductDetails/>}/>
      <Route path='/research-development' element={<Research_Development/>}/>
      <Route path='/our-journey' element={<OurJourney/>}/>
      <Route path='/director-word' element={<DirectorWord/>}/>
      <Route path='/apply-job-form' element={<Applyjobform/>}/>
    </Routes>
  );
};

const App = () => {

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000); // 5 seconds

    return () => clearTimeout(timer);
  }, []);

  // 👇 Preloader first
  if (loading) {
    return <Preloader />;
  }

  // 👇 After 5 sec App show
  return (
    <Router>
      <Header/>
      <HelpWidget/>
      <ScrollToTop/>
      <AppRoutes/>
      <Footer/>
    </Router>
  )
}

export default App